module.exports = __webpack_public_path__ + "static/chyethiamlogo-555a92441c9af6142fd92d604c6ecf1e.png";